import React, { useState, useEffect } from "react";
import { API } from "../../../Common/lib/api";

/**
 * Displays the Publication Year filter section.
 *
 * @param {*} props Contains 'filters' state variable & 'setFilters' state method.
 */
export default function PublicationYearFilter(props) {
  const publicationYearFilters = props.filters.publicationYear;
  const setPublicationYearFilters = props.setFilters;
  const [availableYears, setAvailableYears] = useState([]);

  // Fetch all published projects to extract available publication years
  useEffect(() => {
    const fetchPublicationYears = async () => {
      try {
        const years = new Set();
        let offset = 0;
        const limit = 100;
        let hasMore = true;

        // Fetch all published projects with pagination to get all years
        while (hasMore) {
          const response = await API.listProjects({
            publishStatus: "published",
            limit: limit,
            offset: offset
          });
          
          const projects = response.data.listProjects.items || [];
          const total = response.data.listProjects.total || 0;
          
          projects.forEach(project => {
            if (project.publishedAt) {
              const year = new Date(project.publishedAt).getFullYear();
              if (year && !isNaN(year)) {
                years.add(year);
              }
            }
          });
          
          offset += limit;
          hasMore = offset < total && projects.length > 0;
        }
        
        // Convert to array and sort descending
        const sortedYears = Array.from(years).sort((a, b) => b - a);
        setAvailableYears(sortedYears);
      } catch (e) {
        // Fallback to current year if fetch fails
        const currentYear = new Date().getFullYear();
        setAvailableYears([currentYear]);
      }
    };

    fetchPublicationYears();
  }, []);

  // Adds a year to the filter state based on if a checkbox is checked or not.
  const handleChange = (e) => {
    if (e.target.checked) {
      setPublicationYearFilters((prevState) => {
        const filters = {
          ...prevState,
          publicationYear: [...prevState.publicationYear, e.target.value],
        }
        props.setParam("publicationYear", filters.publicationYear);
        return filters;
      });
    } else {
      let updatedYears = [...publicationYearFilters];
      updatedYears.splice(updatedYears.indexOf(e.target.value), 1);
      setPublicationYearFilters((prevState) => {
        const filters = {
          ...prevState,
          publicationYear: updatedYears,
        }

        if (!filters.publicationYear.length) {
          props.removeParam("publicationYear");
        }
        else {
          props.setParam("publicationYear", filters.publicationYear);
        }
        return filters;
      });
    }
  };

  //Returns A List Of Available Publication Years From Published Projects
  function getYears() {
    return availableYears;
  }

  return (
    <div>
      <div className="space-y-6" >
        {getYears().map((year) => (
          <div key={year} className="flex items-center" >
            <input
              id={year}
              name={year}
              value={year}
              type="checkbox"
              data-cy={year}
              // Saves the "state" of the filter when opening and closing the Disclosure window.
              checked={[...publicationYearFilters].filter((filterOption) => filterOption == year) == "" ? false : true}
              onChange={handleChange}
              className="h-4 w-4 border-gray-300 rounded text-blue-700 focus:ring-blue-700 dark:bg-gray-700 dark:border-gray-600" />

            <label htmlFor={`${year}`} className="ml-3 min-w-0 flex-1 text-gray-500 dark:text-gray-400">
              {year}
            </label>
          </div>
        ))}
      </div>
    </div>
  );
}